// src/components/Auth/AuthLayout.tsx
import React from 'react';

interface AuthLayoutProps {
    children: React.ReactNode;
    title?: string;
    subtitle?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
            <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full">
                <div className="text-center mb-8">
                    <img
                        src="/logo_dark_J9I.png"
                        alt="reg02.top"
                        className="mx-auto h-14 w-auto object-contain"
                    />
                    <p className="mt-2 text-lg font-bold tracking-wide text-gray-800">Chung Sức Liên Quân</p>
                    <p className="mt-1 text-sm font-medium text-gray-500">REG02.TOP</p>
                    {title && <h2 className="text-xl font-semibold text-gray-700 mt-2">{title}</h2>}
                    {subtitle && (
                        <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
                    )}
                </div>
                {children}
            </div>
        </div>
    );
};

export default AuthLayout;